export const TOOLTIP_ERRORS = {
  children:
    'Tooltip component children should be an element or a component that accepts ref, fragments, strings, numbers and other primitive values are not supported',
};
